<template>
    <v-card-text class="justify-center text-center py-4">
        <v-form @submit.prevent="$emit('set-my-bucket',item)" >
            <v-row>
                <v-text-field class="px-4 col col-12" label="Name" solo  v-model="name"></v-text-field>
                <v-text-field class="px-4 col col-12" label="Url" solo  v-model="url"></v-text-field>
                <v-spacer class="col col-10"></v-spacer>
                <v-btn
                    class="col col-2"
                    color="primary"
                    tile
                    @click.stop="$emit('set-my-bucket',editItem)"
                >
                  Save
                </v-btn>
            </v-row>
        </v-form>   
    </v-card-text> 
</template>

<script>
export default {
    name:'EditUrl',
    props:['item'],
    data(){
        return{
            name:'',
            url:'',
            qcode:Date.now().toString()
        }
    },
    mounted(){
        console.log(this.item);
        this.name=this.item.name?this.item.name:'';
        this.url=this.item.data?this.item.data:'';
        this.qcode=this.item.qcode?this.item.qcode:'';
    },
    computed:{
        editItem(){
            return {name:this.name,data:this.url,qcode:this.qcode,type:'url'};
        }
    },
    

}
</script>